"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const documentErrorsLocales_1 = __importDefault(require("./locales/documentErrorsLocales"));
const documentStatusLocales_1 = __importDefault(require("./locales/documentStatusLocales"));
const documentTypesLocales_1 = __importDefault(require("./locales/documentTypesLocales"));
const refusalReasonsLocales_1 = __importDefault(require("./locales/refusalReasonsLocales"));
const statusLocales_1 = __importDefault(require("./locales/statusLocales"));
const languages = Object.keys(documentErrorsLocales_1.default);
const locales = languages.reduce((acc, language) => ({
    ...acc,
    [language]: {
        documentErrors: documentErrorsLocales_1.default[language],
        documentStatus: documentStatusLocales_1.default[language],
        documentTypes: documentTypesLocales_1.default[language],
        errors: refusalReasonsLocales_1.default[language],
        status: statusLocales_1.default[language],
    },
}), {});
exports.default = locales;
